export const root = 'https://backend.upskill.com.bd/api/'
import Upskill from '../upskill'
const api = `${root}`
export const HomeData = `${api}home`
// export const BlogData = 'https://vue-js-blog.herokuapp.com/articles'
export const WorkshopData = Upskill.wsURL
